import React from "react"
import OrderListTableComponent from "./orderListTable.component"

export default function OrderListTableContainer({
  hasStockflowOrderViewAccessRight,
  hasStockflowDealerViewAccessRight,
  type,
  rows,
  isFetching,
  selectedIds,
  isSelectAll,
  isError,
  handleReload,
  page,
  language,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  isSearchResult,
  totalFiltered,
  handleSelectOrder,
  handleSelectAvailable,
  handleSelectAll,
  handleDeselectAll,
  paginationOptions,
  tableFilter,
  changeOrder,
  lang,
  isDealerPage = false,
  displayRequestOnly = false,
  handleViewDetail
}) {
  return (
    <OrderListTableComponent
      hasStockflowOrderViewAccessRight={hasStockflowOrderViewAccessRight}
      hasStockflowDealerViewAccessRight={hasStockflowDealerViewAccessRight}
      type={type}
      rows={rows}
      isFetching={isFetching}
      isSelectAll={isSelectAll} 
      selectedIds={selectedIds}
      isError={isError}
      language={language}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      isSearchResult={isSearchResult}
      totalFiltered={totalFiltered}
      handleSelectOrder={handleSelectOrder}
      handleSelectAvailable={handleSelectAvailable}
      handleSelectAll={handleSelectAll}
      handleDeselectAll={handleDeselectAll}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      isDealerPage={isDealerPage}
      displayRequestOnly={displayRequestOnly}
      handleViewDetail={handleViewDetail}
    />
  )
}